import { VerificationStatus } from '../../Verification/lib/steps/types';
import getProofOfFundsStatus from '../libs/getProofOfFundsStatus';
import { Context } from './model';

const guards = {
  isDocumentUploaded: ({ getModuleData }: Context) => {
    const { company } = getModuleData().proofOfFundsData.viewer;
    const { kybDocuments, lastKybReview, profile } = company;
    const { legalShareCapital } = profile;

    const status = getProofOfFundsStatus({
      company,
      isAccountHolder: true,
      kybDocuments,
      lastKybReview,
      legalShareCapital,
    });

    return (
      status === VerificationStatus.Completed ||
      status === VerificationStatus.Invalid
    );
  },
};

export default guards;
